import { createAsyncThunk } from '@reduxjs/toolkit';

import { findManyCategoryQuery } from '~/shared/graphql-queries';
import { initializeApollo } from '~/shared/libs/apollo/apollo-provider';

export const findManyCategory = createAsyncThunk('categories/findManyCategory', async (args) => {
  const apolloClient = await initializeApollo();

  const result = await apolloClient.query({
    query: findManyCategoryQuery,
    variables: {
      filter: args?.filter,
      limit: args?.limit,
    },
  });

  return result?.data?.findManyCategoryQuery;
});
